import(/* webpackMode: "eager" */ "/var/www/front/front-test/app/books/page.tsx")